import request from '@/utils/request'

export function getUsers() {
  return request({
    url: '/config-service/v1/account',
    method: 'get'
  })
}

export function getBookingGroups() {
  return request({
    url: '/booking-service/v1/lost-item/booking-code',
    method: 'get'
  })
}

export function getList(query) {
  return request({
    url: '/booking-service/v1/lost-item',
    method: 'get',
    params: query
  })
}

export function addLostAndFound(query) {
  return request({
    url: '/booking-service/v1/lost-item',
    method: 'post',
    data: query
  })
}

export function updateLostAndFound(query) {
  return request({
    url: '/booking-service/v1/lost-item',
    method: 'put',
    data: query
  })
}

export function deleteLostAndFound(query) {
  return request({
    url: '/booking-service/v1/lost-item',
    method: 'delete',
    data: query
  })
}
